enum FileType {
    File2D,
    File3D,
    File3DFrom2D
}

export default FileType;